import { useLocation } from 'react-router';
import { useAuth } from '../auth/AuthProvider';
import { useI18n } from '../i18n';
import { Button } from '../components/ui';

export function Login({ noMembership }: { noMembership?: boolean }) {
  const { login, logout } = useAuth();
  const { t } = useI18n();
  const location = useLocation();
  const returnTo = (location.state as { from?: string } | null)?.from ?? '/';
  return (
    <div className="login">
      <div className="card">
        <div className="wordmark" style={{ justifyContent: 'center', fontSize: '1.4rem', marginBottom: '0.5rem' }}><span className="a">Avia</span><span className="b">Console</span></div>
        <div className="muted small" style={{ marginBottom: '1.5rem' }}>AvioData · Billing console</div>
        {noMembership ? (
          <>
            <p className="secondary" style={{ fontSize: '0.88rem' }}>{t('notMember')}</p>
            <Button onClick={() => void logout()} icon="fas fa-right-from-bracket">{t('signOut')}</Button>
          </>
        ) : (
          <>
            <p className="secondary" style={{ fontSize: '0.88rem', textWrap: 'pretty' }}>{t('signInHint')}</p>
            <Button variant="primary" icon="fas fa-fingerprint" block onClick={() => login(returnTo)}>{t('signIn')}</Button>
          </>
        )}
      </div>
    </div>
  );
}
